import { request } from '@/utils/ajax';
import { FeeConfiguration, ProjectFeeSet, ProjectFeeSetWithReferenceCount, PriceCalculationResult } from '@/types';
import { OptionalId } from '@ygtechnologies/bygr-frontend-component-library';

export function getFeePreview(
    basePrice: number,
    quantity: number,
    fees: FeeConfiguration[],
    projectId?: number
): Promise<PriceCalculationResult> {
    return request(`api/fee/preview`, {
        method: 'POST',
        json: true,
        body: {
            basePrice,
            quantity,
            fees,
            projectId,
        },
    }).then((x) => x.json());
}


export interface ProjectFeeOverrideSettings {
    orders?: boolean;
    options?: boolean;
    offers?: boolean;
    changeRequests?: boolean;
    externalAgreements?: boolean;
    optionPresets?: boolean;
}

export function getProjectFeeSets(projectId: number): Promise<ProjectFeeSet[]> {
    return request(`api/project/${projectId}/fee-sets`).then((x) => x.json());
}

export function getProjectFeeSetsWithReferenceCount(projectId: number): Promise<ProjectFeeSetWithReferenceCount[]> {
    return request(`api/project/${projectId}/fee-sets/with-reference-count`).then((x) => x.json());
}

export function saveProjectFeeSet(
    projectId: number,
    projectFeeSet: OptionalId<ProjectFeeSet>,
    overrideSettings: ProjectFeeOverrideSettings | null
): Promise<ProjectFeeSet> {
    return request(`api/project/${projectId}/fee-sets`, {
        method: 'POST',
        json: true,
        body: { projectFeeSet, overrideSettings },
    }).then((x) => x.json());
}
export async function deleteProjectFeeSet(projectId: number, projectFeeSetId: number) {
    await request(`api/project/${projectId}/fee-sets/${projectFeeSetId}`, {
        method: 'DELETE',
    });
}

export function saveProjectFees(
    projectId: number,
    fees: FeeConfiguration[],
    overrideSettings: ProjectFeeOverrideSettings | null
) {
    return request(`api/project/${projectId}/fees`, {
        method: 'PUT',
        json: true,
        body: { rows: fees, overrideSettings },
    });
}
